import React from 'react';

function Cover() {
    const scrollToAbout = () => {
        const aboutElement = document.getElementById('about');
        if (aboutElement) {
            aboutElement.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className="t-cover" style={{ backgroundImage: "url('https://static.tildacdn.pub/tild6465-6238-4233-a666-643236663030/4f6b1eaf-5576-49e9-8.png')", height: '100vh' }}>
            <div className="t-cover__filter"></div>
            <div className="t-container">
                <div className="t-col t-col_8">
                    <div className="t-cover__wrapper t-valign_middle" style={{ height: '100vh' }}>
                        <div className="t181">
                            <div className="t181__wrapper">
                                <div className="t181__title t-title t-title_md animated-text">
                                    Трайтек — лидер в интеграционном бизнесе
                                </div>
                                <div className="t181__descr t-descr t-descr_lg animated-text-delay">
                                    Надёжный партнёр для автоматизации бизнеса, промышленных предприятий и государственных учреждений
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Стрелка вниз */}
            <div className="cover-arrow" onClick={scrollToAbout}>
                <span className="arrow-symbol">⌄</span>
            </div>
        </div>
    );
}

export default Cover;